export default {
    site: {
        common: {
            hello: "Ahoj",
            thankYou: "Ďakujem",
            forMoreInfo: "ďalšie informácie",
            hoverOverColumnHeaders: "Umiestnite kurzor myši nad hlavičky stĺpcov a získajte ďalšie informácie.",
            username: "meno používateľa",
            score: "Skóre",
            points: "Počet bodov",
            pointsAbbreviation: "pb",
            chapter: "Kapitola",
            tier: "Úroveň",
            t1: "U1",
            t2: "U2",
            t3: "U3",
            collectionsPerDay: "Zber za deň",
            relicBoostPercent: "Posilnenie relikvií %",
            mountainHallPercentShort: "Horská budova %", // used in table heading keep it short.
            updated: "aktualizované",
            lastUpdated: "Naposledy Aktualizované",
            created: "vytvorené",
            role: "titul",
            Fellow: 'Člen',
            Ambassador: 'Veľvyslanec',
            Mage: 'Zástupca Veliteľa',
            Archmage: 'Veliteľ',
            saveChanges: "Uložiť zmeny",
            copy: "Kopírovať",
            close: "Zavrieť",
            cancel: "Zrušiť",
            action: "Akcia",
            date: "Dátum",
            Left: "Opustil",
            Joined: "Pridal sa",
            human: "Ľudia",
            elf: "Elfovia",
            search: "Vyhľadaj",
            enter: "Zadaj",
            yes: "Áno",
            no: "Nie",
            tournament: "Turnaj",
            tournaments: "Turnaje",
            fellowship: "Spoločenstvo",
            player: "Hráč",
            member: "Člen",
            history: "História",
            tournamentHistory:  "História turnajov",
            scoreHistory: "História skóre",
            server: "Server",
            lastWeekGain: "Zisk minulého týždňa",
            comingSoon: "Už čoskoro",
            chest: "poklad",
            yourServer: "Tvoj Server",
            allServers: "Všetky Servery",
            boosts: "posilnenia",
            marble: "mramor",
            steel: "oceľ",
            planks: "drevo",
            crystal: "krištál",
            scrolls: "zvitky",
            silk: "hodváb",
            elixir: "elixíry",
            magic_dust: "kúzelný prach",
            gems: "drahokamy",
            sentient: "cítiaci",
            goods: "tovar",
            average: "priemer",
            expansions: 'Rozšírenia', // 5x5 grids
            cultureBoostMinimum: 'Kultúrny Bonus Min',
            cultureBoostCalculated: 'Kultúrny bonus (vypočítaný)',
            neighborlyHelp: 'Susedská výpomoc',
            neighborlyHelpAbbreviation: 'SV'
        },
        // HIGH PRIORITY
        nav: {
            home: "Domov",
            players: "Hráči",
            fellowships: "Spoločenstvá",
            tournaments: "Turnaje",
            contact: "Kontakt",
            donate: "Príspevok",
            faq: "FAQ",
            news: "Novinky",
            privacyPolicy: "Zásady ochrany osobných údajov",
            me: "Moje mesto",
            myFellowship: "Moje Spoločenstvo",

            // NOTE USED AT THE MOMENT
            globalStats: "Globálne Štatistiky",
            articles: "Články",
            fellowshipAdventure: "Dobrodružstvá Spoločenstva",
            recruit: "Nábor",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Zobraziť mesto na ElvenArchitect"
            ,obtainingLink: "Získanie odkazu"
            ,successMessage: "Úspech! Kliknite na odkaz nižšie pre spustenie Elven Architect-a"
            ,ageOfLink: "Nad týmto odkazom sa zobrazí mesto tak, ako bolo: "
            ,clickToGetCurrentCity: "<-- Kliknutím získate novšiu štatistiku mesta",
        },
        // High Priority
        playerSelection: {
            headline: "Zobraziť stránku ako",
            description: "Tým sa aktualizujú rôzne časti stránok, ktoré sú prispôsobené používateľovi webu. Medzi príklady patria: moje spoločenstvo, moje mesto, turnaje a stránky s hodnotením.",
            youAreViewing: `Stránky teraz prehliadate ako {username} na serveri {serverName}.`,
            changeUser: "Zmeniť hráča",
            enterYourUsernameToGetStarted: "Zadaj prihlasovacie meno do Elvenaru",
            thisIsNotASignup:"Toto nie je proces registrácie. Zadaním svojho používateľského mena Vám stránky len jednoducho vhodne prispôsobíme. Existuje veľa Elvenar serverov a zobrazíme výsledky štatistík pre váš server. Takisto budú k dispozícii aj odkazy priamo na vaše spoločenstvo a vaše mesto."
        },
        searchBoxes: {
            enterFellowshipName: 'Zadajte názov spoločenstva',
            instructions: "Zadajte meno a vyberte ho.",
            noFellowship: "Žiadne Spoločenstvo",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "pred dňami",
            minsAgo: "pred minútami",
            hoursAgo: "pred hodinami",
            justNow: "práve teraz",
            never: "Nikdy",
        },
        home: {
            welcome: "Vitajte na stránkach Elven Stats!",
            youAreViewing: "Stránky prehliadate ako {username} na serveri {serverName}",
            youCanChange: "Zmeniť používateľa môžete kliknutím na avatara vpravo hore, alebo <router-link to='/contact'>na tejto stránke</router-link>",
            features: {
                headline: "Možnosti",
                fellowshipAdministration: {
                    headline: "<strong>JEDNODUCHÁ</strong> Administrácia Spoločenstva",
                    bullet1: "Automatické sledovanie posilneného tovaru, ktoré vám pomôže lepšie vyvážiť vaše spoločenstvo",
                    bullet2: "Automatické sledovanie / generovanie týždenných e-mail správ, ktoré zahŕňajú body, účasť na turnajoch, mesačný rast a motiváciu \"Vyznamenania \" a osobné rekordy",
                    bullet3: "Pomoc s identifikovaním výrobnej nerovnováhy vašich kolegov ako výroba zásob alebo nesprávny pomer úrovní manufaktúr",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Integrácia</strong> s ElvenArchitect-om",
                    description: "Zobrazte svoje mesto presne také, ako je priamo v ElvenArchitect-ovi za pár sekúnd! Použite ho na lepšie naplánovanie ďalšej veľkej reorganizácie mesta alebo na nájdenie miesta, ktoré si neuvedomujete, že máte! Hľadajte logo ElvenArchitect-a na stránkach hráča."
                },
                advancedRankingLists: {
                    headline: "Rozšírené <strong>Zoznamy Poradia</strong>",
                    bullet1: "Zoznam poradia podľa odomknutých oblastí (pre porovnanie sa s ľuďmi v rovnakej fáze)",
                    bullet2: "Zobrazenie Posilnení, Čísla kapitoly a ďalších v zoznamoch hráčov.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Sledovanie</strong> Spoločenstva v Turnaji",
                    description: "Zistite, ako sa vášmu spoločenstvu v turnaji darí voči ostatným. Vyzvite ďalšie spoločenstvá na duel v priateľskej súťaži!",
                },
                matchMaking: {
                    headline: "Nájdite <strong>Zhodu</strong>",
                    description: "ElvenStats sleduje posilnenia hráčov a produkciu tovarov v spoločenstvách. S týmito infomáciami vedia spoločenstvá vyhľadávať správnych kandidátov pre vyrovnanú produkciu tovarov. Hráči môžu vyhľadávať spoločenstvá, ktoré vlastne potrebujú ich posilnenia tovaru, čo šetrí čas a redukuje počet možných odmietnutí!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Umiestnenie",
                points: "Počet bodov",
                medianUserScore: "Medián <strong>Skóre</strong>",
                memberCount: "<strong>Počet</strong> Členov ",
            },
            barCharts: {
                clickSlice: "Kliknite na položky pre detaily (podľa členov)",
                tier1: "Úroveň 1",
                tier2: "Úroveň 2",
                tier3: "Úroveň 3",
                drillDown: "Späť na {0}"
            },
            idealCandidate: {
                heading: "Ideálny Kandidát",
                description: "By mal mať skóre okolo {medianScore} a jedno alebo viacero posilnení z nasledujúcich: {boosts}",
                note: "Niektoré kombinácie posilnení nie sú možné. Pozri {0}"
            },
            memberGoodsTable: {
                heading: "Produkcia Tovaru",
                description: `Táto tabuľka zobrazuje, koľko tovaru vaše spoločentsvo vyrobí. Do úvahy berieme výšku percentulálneho posilnenia výroby tovarov jednotlivých členov spoločenstva a predpokladáme, že každý člen zozbiera tovar 3x denne (2x9h a 1x3h). Ak chcete zlepšiť presnosť, opýtajte sa svojich členov na to, aké sú ich skutočné hodnoty zberu, a zadajte ich nižšie. Zadané môžete uložiť, aby sa zobrazilo pri ďalšom načítaní tejto stránky. Stĺpcové grafy vyššie sa po vykonaní zmien automaticky aktualizujú. Umiestnite kurzor myši nad hlavičky stĺpcov pre viac informácií o konkrétnom stĺpci.'
                `,
                refreshButtonText: 'Obnoviť Zoznam členov',
                refreshButtonTip: 'Týmto sa automaticky pridajú noví členovia, odstránia starí, aktualizujú sa roly členov a skóre.',
                inactiveWarningTip: 'Používateľ môže byť neaktívny, Naposledy aktualizované skóre: {0}',
                collectsPerDayValidation: "Musí byť medzi 1-6",
                boostPercentValidation: "Musí byť medzi 40 - 700, nezahŕňa bonus Horskej budovy",
                perDayShort: "/deň",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Skóre hráčov, nieje aktualizované v reálnom čase. Aktualizuje sa niekoľkokrát do týždňa.",
                chapterTip: "Kapitola v ktorej sa hráč nachádza.  Napríklad: Elementáli = 12, Hobbiti = 11, atď.",
                boostTip: "Posilnenie tovaru hráča a množstvo produkované každý deň.",
                collectsPerDayTip: `***EDITABLE*** <br/>Počet zberov za deň. Počet koľko krát hráč zbiera tovar zo svojich manufaktúr. Hodnota by mala byť medzi 1 - 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Bližšie info FAQ.`,
                relicBoostPercentTip: `***EDITABLE***<br/>Percentuálne posilnenie tovaru z relikvií, medzi 40-700.  Nezahŕňa bonus Horskej budovy. Ten sa zisťuje automaticky a je aj pripočítaný`,
                mountainHallPercentTip: "Percentuálne posilnenie tovaru Horskou budovou.  Je použité v spojení s Percentuálnym posilnením tovaru pre výpočet Celkového posilnenia výroby tovarov",
                updatedTip: "Čas poslednej analýzy hráčovho mesta. Tento proces je zodpovedný za nastavenie posilnenia tovaru, dáta pre ElvenArchitect-a, vypočítava produkciu zo všetkých manufaktúr, Horskej budovy, atď... Mapové údaje mesta sa pravidelne automatický načítajú, ale aktualizáciu môžete vynútiť kliknutím na tlačidlo obnovenia.",

            },
            coinsAndSuppliesTable: {
                heading: "Mince / Zásoby Produkcia",
                description: `Kľúčovým stĺpcom je "Zostatok Zásob", pretože označuje, či člen bude produkovať dostatok zásob na to, aby jeho manufaktúry dokázali vyrábať 24 hodín denne, 7 dní v týždni. Použite prepínače nižšie, aby ste zohľadnili minimálny bonus kultúry hráčov (čo je nárast, ktorý by ste mali, keby ste nemali žiadnu susedskú výpomoc) a / alebo počet, koľkokrát daný člen zhromažďuje za deň (ako je uvedené vyššie v Tabuľke tovaru) , Vypnutie obidvoch funkcií je užitočné, ak chcete vidieť, koľko zásob sa pripisuje viacerým manufaktúram alebo vyššiemu bonusu kultúry. Teeba si uvedomiť, že nízke záporné (~ 10% celkového) číslo zostávajúcich zásob je pomerne bežné. 
Existuje mnoho spôsobov, ako hráči dopĺňajú svoje zásoby, napríklad tým, že navštevujú susedov a vyrábajú zásoby v rýchlejších intervaloch (nápoje, jednoduché nástroje, chlieb ...) alebo pomocou kúzla Sila Zásob. Vnímajte negatívnu hodnotu ako to, čo by ste museli robiť denne pomocou jednej z týchto možností. POZNÁMKA: V súčasnosti sa výroba vojsk nezapočítava do Použitých Zásob (iba výroba tovaru Úrovne 1, Úrovne 2 a Úrovne 3), takže je dosť možné, že budete potrebovať viac zásob.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min %",
                made: "Vyrobené",
                used: "Použité",
                left: "Zostatok",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Percentuálne posilnenie kultúry.  DÔLEŽITÉ: číslo vychádza z predpokladu, že na kultúrnych budovách nieje aplikovaná susedská výpomoc. V skutočnosti bude vo vašich mestách pravdepodobne vyššie.",
                moneyComputedTip: "Množstvo mincí vyprodukovaných za deň, zahŕňa postavené Staroveké Divy, ktoré produkujú mince",
                moneyUsedComputedTip: "Množstvo mincí spotrebovaných pri výrobe tovaru.",
                moneyRemainingComputedTip: "Mince - Použité Mince, je to prebytok alebo deficit mincí, ktoré hráč má každý deň k dispozícii",
                suppliesComputedTip: "Počet zásob, ktoré by boli vyrobené, keby boli všetky dielne nastavené na 24x1 (Sady nástrojov) + všetky Staroveké Divy. (nezahŕňa bonus zo SET budov)",
                suppliesUsedComputedTip: "Počet zásob spotrebovaných pri výrobe tovaru. Nezahŕňa zásoby spotrebované v kasárňach! Pozri vysvetlenie vyššie.",
                suppliesRemainingComputedTip: "Zásoby - Použité Zásoby, je to prebytok alebo deficit zásob, ktoré hráč má každý deň k dispozícii",
                manaTip: "Množstvo Many vyrobené za 24 hodín (nezahŕňa Dračí Chrám)",
            },
            popCultureTable: {
                heading: "Populácia/Kultúra Detaily",
                description: 'Nasledujúca tabuľka zobrazuje populáciu / kultúru každého hráča. Umiestnite kurzor myši nad hlavičky stĺpcov a získajte ďalšie informácie.',

                // Icon Sub-Headings
                minBoostPercent: "Min %",
                levels: "Úrovne",
                total: "Celkovo",
                working: "Pracujúci",
                available: "Dostupné",
                required: "Požadované",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Celkový počet úrovní Starovekých Divov.",
                cultureBoostPercentTip: "Percentuálne posilnenie kultúry.  DÔLEŽITÉ: číslo vychádza z predpokladu, že na kultúrnych budovách nieje aplikovaná susedská výpomoc. V skutočnosti bude vo vašich mestách pravdepodobne vyššie.",
                totalPopulationTip: "Celková Populácía produkovaná obytnými budovami, hybridnými budovami typu kultúra/populácia and starovekými divmi",
                workingPopulationTip: "Pracujúca Populácia - Množstvo používané budovami",
                availablePopulationTip: "Dostupná Populácia",
                totalCultureTip: "Celková Kultúra produkovaná kultúrnymi budovami, hybridnými budovami typu kultúra/populácia and starovekými divmi",
                requiredCultureTip: "Požadovaná Kultúra pre všetky budovy",
                availableCultureTip: "Dostupná Kultúra",
            },
            cityCoverageTable: {
                heading: "Pokrytie Mesta",
                description: "Zobrazuje, koľko dlaždíc sa používa v jednotlivých mestách členov pre daný typ budovy. Prázdne dlaždice sú dlaždice, ktoré sa v súčasnosti nepoužívajú.",
                tiles: 'Tiles'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Týždenný Email Report",
                description: "Vytvárame automaticky týždenné prehľady vhodné na zdieľanie s vašim spoločenstvom. Nový týždenný prehľad za predchádzajúci týždeň bude k dispozícii každú nedeľu (približne okolo 20:00 UTC). Jednoducho skopírujte nápis nižšie a vložte!",
                selectReportHint: "Vyberte Report pre týždeň, končiaci",
                reportsAreOptimizedFor: "E-mailové prehľady sú optimalizované na zobrazenie v systéme zasielania správ pre Elvenar. Stĺpce sú čo možno najviac zarovnané a používateľské mená sú skrátené, aby sa zmestili do jednej správy.",
                accolades: "vyznamenania",
                tourneyChamp: " - Šampión Turnaja (tento týždeň): {0}",
                tourneyHero: " - Hrdina Turnaja (posledné 4 týždne): {0}",
                highestGrowthPlusPercentage: " - Najvyšší rast (bodovo & percentuálne): {0}",
                highestGrowthPoints: " - Najvyšší rast (bodovo): {0}",
                highestGrowthPercentage: " - Najvyšší rast (percentuálne): {0}",
                highestGrowthError: " - Najvyšší rast: Nieje možné určiť, potrebujeme viac informácií-histórie",
                newPersonalRecords: "Nové osobné rekordy",
                userSetANewPersonalRecordFor: " * {0} nastavil nový osobný rekord pre: {1}",
                allMembersByPointGainThisWeek: "VŠETCI ČLENOVIA podľa Bodového zisku / Percentuálne (tento týždeň)",
                tournamentPointsHeader: "Turnajové Body (tento týždeň / CELKOVO od {0})",
                top8ByPercentage: "TOP 8 podľa Percent (tento týždeň)",
                top8ByPointsSince: "TOP 8 podľa Bodov (Od {0})",
                top8ByPercentageSince: "TOP 8 podľa Percent (Od {0})",
                reportGeneratedBy: "Správa generovaná použitím elvenstats.com, viac informácií nájdete na: ",
                mostPointsInAWeek: "Najviac Bodov za Týždeň",
                highestTournamentScore: "Najvyššie Skóre v Turnaji",
                highestTournamentRank: "Najvyššie umiestnenie v Turnaji",
                insufficientHistoryForThesePlayers: "* Vynechané: {0} z dôvodu nedostatku historických údajov. Bude zahrnuté budúci týždeň",
                insufficientHistory1Week: "* Nedostatok histórie pre túto sekciu. Skúste budúci týždeň!",
                insufficientHistory4Weeks: "* Nedostatok histórie pre túto sekciu. Sú potrebné historické údaje aspoň za 4-ri týždne. Skúste budúci týždeň!",
            },
            memberHistory: {
                heading: "História členov spoločenstva",
                noChangesDetected: "Zatiaľ neboli odhalené žiadne zmeny od spustenia sledovania spoločenstva od {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Máte neuložené zmeny. Po dokončení úprav spoločenstva kliknite na tlačidlo Uložiť.',
                standbyImporting: 'Počkajte: Importujeme členov spoločenstva, ktorím chýbajú údaje',
                limitedHistory: "Nedávno sme začali sledovať toto {0}, takže máme obmedzenú históriu. Každú nedeľu získavame nové týždenné prehľady, preto sa nezabudnite vrátiť!",
                noChangesSinceTrackingBegan: "Žiadne zmeny od začiatku sledovania",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "História Spoločenstva"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Aktualizácie v reálnom čase sú momentálne nedostupné.",
            realTimeUpdatesNotAvailableDescription: "Toto sa zvyčajne stáva po reštartovaní Elvenar serverov, aby sa zaviedla aktualizácia alebo údržba. Akonáhle k tomu dôjde, ElvenStats sa musí manuálne prihlásiť na všetky herné servery predtým, než budú informácie na požiadanie dostupné. Skúste svoju požiadavku zopakovať o niekoľko hodín. Medzitým je však web plne funkčný.",
            copyToClipboardSuccessful: "Kopírovanie do schránky bolo úspešné!",
            copyToClipboardFailed: "Kopírovanie zlyhalo, zvýraznite celú oblasť textu a potom stlačte CTRL+C",
            errorOccurredImporting: "Chyba pri importovaní hráčov.",
            errorOccurredImportingMessage: "Vznikla chyba pri importovaní hráčov.  Prosím skúste znova.  V prípade, že sa chyba opakuje, kontaktujte nás prosím.",
            errorOccurredImportingWillNotBeAvailableInReports: "Hráči, ktorí neboli naimportovaní nebudú zahrnutí v štatistikách.",
            finishedSyncSuccessful: "Dokončené, synchronizácia bola úspešná!",
            playerIsAnonymous: "Hráč požiadal, aby jeho informácie neboli zobrazené na elvenstats.com",
            inactiveWarningTip: "Tento hráč môže byť neaktívny. Skóre naposledy zmenené: {0}",
            isFriendTip: "Tento hráč je priateľom ElvenStats. Buď prispeli svojím voľným časom alebo finančne na podporu tejto stránky!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/sk.js